import Component from "../../lib/component";

export const CrewMessagerConfig = {
    componentTypeKey: 'CrewMessager',
    baseHtmlClass: 'crew_messager',
    selector: '.crew_messager',

    linkElementSelector: '.crew_messager__link',
};

export class CrewMessager extends Component {

    constructor(id_or_element, options = {}) {
        super({
            element: id_or_element,
            config: CrewMessagerConfig
        });

        this.focused = false;
        this.linkElement = this.element.querySelector(CrewMessagerConfig.linkElementSelector);
        this.linkElement.addEventListener('focus', this.handleFocus.bind(this));

        this.element.addEventListener('mouseenter', this.handleMouseenter.bind(this));
        this.element.addEventListener('mouseleave', this.handleMouseleave.bind(this));

        this.addHtmlClassState('inited');

    }

    handleFocus() {
        this.focused = true;
        this.render();
    }

    handleMouseenter() {
        this.focused = true;
        this.render();
    }

    handleMouseleave() {
        this.focused = false;
        this.render();
    }

    render() {
        this.conditionallySetHtmlClassState(this.focused, 'focused');
    }

}
